import BODY_CATEGORIES from './body_categories';

const BODY_PRODUCT_TYPES = {};
BODY_PRODUCT_TYPES[BODY_CATEGORIES.FULL_BODY] = [
  'Body Cleanser',
  'Body Exfoliator',
  'Bath Soak/Bubble Bath',
  'Bath Bar/Soap',
  'Body Moisturizer',
  'Body Sunscreen',
  'After-Sun/Self-Tanner',
  'Body Treatment',
];
BODY_PRODUCT_TYPES[BODY_CATEGORIES.HANDS] = [
  'Hand Cleanser',
  'Hand Sanitizer',
  'Hand Moisturizer',
  'Hand Exfoliator',
  'Hand Treatment',
  'Foot Cleanser',
  'Foot Moisturizer',
  'Foot Exfoliator',
];
BODY_PRODUCT_TYPES[BODY_CATEGORIES.FACE] = [
  'Face Sunscreen',
  'Face After-Sun',
  'Face Self-Tanner',
  'Lip Moisturizer',
  'Lip Exfoliator',
  'Lip Sunscreen',
  'Lip After-Sun',
  'Teeth Cleaning',
];
BODY_PRODUCT_TYPES[BODY_CATEGORIES.LEGS] = [
  'Hair Removal',
  'Firming',
  'Stretchmarks',
  'Cellulite',
  'Slimming/Toning',
];
BODY_PRODUCT_TYPES[BODY_CATEGORIES.UNDERARMS] = [
  'Deodorant',
  'Anti-Perspirant',
  'Hair Removal',
  'Brightening',
];

export default BODY_PRODUCT_TYPES;
